<template>
  <!-- :action="$http.uploadUrl" -->
  <!-- :on-success="handleSuccess" -->
  <div>
    {{ $attrs.code }}
    <el-upload
      class="themeUploadAvatar"
      accept=".jpg,.jpeg,.png"
      action=""
      :show-file-list="false"
      :before-upload="beforeUpload"
      :http-request="uploadData"
    >
      <el-image v-if="imageUrl" :src="imageUrl" class="avatar" fit="fit">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline" />
        </div>
      </el-image>
      <!-- <img v-if="imageUrl" :src="imageUrl" class="avatar"> -->
      <i v-else class="el-icon-plus avatar-uploader-icon" />
      <div slot="tip" class="el-upload__tip btn-tip">仅支持 jpg/png格式图片</div>
    </el-upload>
  </div>

</template>
<script>
import { uploadFile } from '@api/api_common'
export default {
  props: {
    // 上传的文件
    fileList: {
      type: Array,
      default: function () {
        return []
      }
    },
    // 用于接口 传参 确定文件名编码用
    code: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // imageUrl: ''
    }
  },
  computed: {
    list: {
      get() {
        return this.fileList
      },
      set(val) {
        this.$emit('update:fileList', val)
      }
    },
    imageUrl() {
      if (this.fileList[0] && this.fileList[0].url) {
        return this.fileList[0].url
      } else {
        return ''
      }
    }
  },

  methods: {
    uploadData(data) {
      const formData = new FormData()
      formData.append('file', data.file)
      formData.append('code', this.code)
      uploadFile(formData).then(res => {
        const response = { name: res.fileOriginalName, paramsFileName: res.fileName, paramsUrl: res.filePath, url: res.rootPath, id: res.id, uid: data.file.uid }
        this.list = [response]
        this.$message.success('上传成功')
      })
    },
    // 图片上传前检测
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG && !isJPEG) {
        this.$message.error('应上传 JPG/PNG 格式!')
      }
      return isLt10M || isJPG || isJPEG || isPNG
    }
    // 图片上传成功后传值
    // handleSuccess(res, file) {
    //   this.$emit('update:key', res.files.file)
    //   this.imageUrl = URL.createObjectURL(file.raw)
    // }
  }
}
</script>

<style lang="scss">
  .themeUploadAvatar{
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar {
      width: 100px;
      height: 100px;
      display: block;
    }
    .btn-tip{
      display: block;
      margin-left: 0;
      line-height: initial;
      color: #898884;
      margin-top: -4px;
    }
    .el-upload:hover {
      border-color: #FDC100;
      .el-icon-plus:before{color: #FDC100;}
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
  }

</style>

